// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__FEoDL","title":"ClientReferral_title__1RNvY","itemText":"ClientReferral_itemText__913rN"};